/* =====================================================================
   PARALLEL · app.js
   =====================================================================

   ░░ SHOPIFY THEME BUILD ░░

   The switches that used to live here are now Shopify's job:

     STORE_OPEN / PASSWORD  →  Online store > Preferences > Password protection.
                               Shopify serves layout/password.liquid while the
                               store is locked, and drops it the moment it opens.
     CHECKOUT_URL           →  gone. Checkout is Shopify's, posted to /cart.
     PRODUCTS               →  gone. Product data comes from Liquid, so price,
                               sizes, photos and stock are whatever the admin says.

   Nothing in this file needs editing on a drop cycle any more.
   ===================================================================== */

(() => {
  'use strict';
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* =================================================================
     TOAST  (defined early · the gate + footer forms use it too)
     ================================================================= */
  let toastT = null;
  function toast(msg, ok){
    let t = $('.toast');
    if (!t){ t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role','status'); document.body.appendChild(t); }
    t.innerHTML = ok ? `<span class="ok">●</span> ${msg}` : msg;
    requestAnimationFrame(() => t.classList.add('show'));
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 2200);
  }


  /* =================================================================
     PRODUCT PAGE · media rail
     -----------------------------------------------------------------
     Name, price, description, specs and sizes are all rendered by
     sections/main-product.liquid from live product data. This block only
     drives the gallery swap.
     ================================================================= */
  const pdp = $('.pdp');
  if (pdp){
    const stack = $('[data-gallery]', pdp);
    if (stack){
      const big   = $('#p-img', pdp);
      const media = $('.pdp__media', stack);
      const rail  = $$('.pdp__rail button', stack);
      rail.forEach((b, i) => b.addEventListener('click', () => {
        rail.forEach(x => x.classList.remove('is-on'));
        b.classList.add('is-on');
        if (big && b.dataset.src){
          big.src = b.dataset.src;
          if (b.dataset.srcset) big.srcset = b.dataset.srcset;
          big.alt = b.dataset.alt || '';
        }
        // the tech-pack annotations only describe the front shot
        media && media.classList.toggle('no-annot', i !== 0);
      }));
    }
  }

  /* =================================================================
     NAV
     ================================================================= */
  const nav = $('.nav'); let lastY = 0;
  addEventListener('scroll', () => {
    const y = scrollY;
    if (nav) nav.classList.toggle('hide', y > lastY && y > 200 && !nav.classList.contains('open'));
    lastY = y;
  }, {passive:true});
  const burger = $('.nav__burger'), mm = $('.mobilemenu');
  burger && burger.setAttribute('aria-expanded','false');
  burger && burger.addEventListener('click', () => {
    const open = !mm.classList.contains('open');
    nav.classList.toggle('open', open); mm.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('locked', open);
  });
  $$('.mobilemenu a').forEach(a => a.addEventListener('click', () => {
    nav.classList.remove('open'); mm.classList.remove('open');
    burger && burger.setAttribute('aria-expanded','false');
    document.body.classList.remove('locked');
  }));

  /* =================================================================
     ANNOUNCEMENT BAR · gentle fade-rotator (big-brand retail strip)
     ================================================================= */
  const annos = $$('.anno__msg');
  if (annos.length > 1){
    let ai = 0;
    setInterval(() => {
      const prev = ai;
      annos[prev].classList.remove('on'); annos[prev].classList.add('out');
      ai = (ai + 1) % annos.length;
      annos[ai].classList.remove('out'); annos[ai].classList.add('on');
      setTimeout(() => annos[prev].classList.remove('out'), 600);
    }, 3400);
  }

  /* =================================================================
     THE GAP RAIL · the signature. Two lines at the left edge; the gap
     between them = how far you are from the footer. Scroll = the work.
     They meet at the bottom: the life you live catches the one you build.
     ================================================================= */
  const rail = $('.gaprail');
  if (rail && !reduce){
    const b = $('.gaprail__b', rail), lbl = $('.gaprail__lbl', rail);
    let raf = null;
    const upd = () => {
      raf = null;
      const max = document.documentElement.scrollHeight - innerHeight;
      const p = max > 60 ? Math.min(1, Math.max(0, scrollY / max)) : 1;
      const gap = Math.round((1 - p) * 100);
      if (b) b.style.transform = `translateX(${((1 - p) * 26).toFixed(1)}px)`;
      if (lbl) lbl.textContent = gap <= 0 ? 'THE GAP · CLOSED' : `THE GAP · ${String(gap).padStart(2,'0')}%`;
      rail.classList.toggle('aligned', gap <= 0);
    };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(upd); }, {passive:true});
    addEventListener('resize', upd, {passive:true});
    upd();
  }

  /* =================================================================
     MANIFESTO CONVERGE · scrub --p 0→1 while the section crosses the
     viewport; the two lives slide together and the future fills blue.
     ================================================================= */
  const man = $('.manifesto[data-scrub]');
  if (man && !reduce){
    man.style.setProperty('--p', '0');
    let raf = null;
    const upd = () => {
      raf = null;
      const r = man.getBoundingClientRect();
      let p = (innerHeight - r.top) / (innerHeight + r.height);
      p = (p - .18) / .5;                       // finish converging ~2/3 through
      man.style.setProperty('--p', Math.min(1, Math.max(0, p)).toFixed(3));
    };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(upd); }, {passive:true});
    addEventListener('resize', upd, {passive:true});
    upd();
  }

  /* =================================================================
     REVEALS
     ================================================================= */
  const io = new IntersectionObserver((es) => {
    es.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  }, {threshold:.16, rootMargin:'0px 0px -8% 0px'});
  $$('[data-reveal]').forEach(el => io.observe(el));

  // split-text reveal (word level, masked rise)
  $$('.split').forEach(el => {
    const words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map(w => `<span class="word"><span>${w}</span></span>`).join(' ');
    $$('.word > span', el).forEach((s,i) => s.style.transitionDelay = (i*0.06)+'s');
  });
  const splitIO = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting){ e.target.classList.add('in'); splitIO.unobserve(e.target); }
  }), {threshold:.25, rootMargin:'0px 0px -8% 0px'});
  $$('.split').forEach(el => splitIO.observe(el));

  /* =================================================================
     THE ARCHIVE · case-file filter + the claim-ticket lightbox
     The tee's graphic is a lost-property tag, so every photo is filed
     as a recovered item: a claim number, a location, a status.
     ================================================================= */
  const goTo = (top) => {
    if (window.__lenis) window.__lenis.scrollTo(top, {duration: reduce ? 0 : 1});
    else scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
  };

  const fbtns = $$('.filters__b');
  if (fbtns.length){
    const files = $$('.file');
    fbtns.forEach(b => b.addEventListener('click', () => {
      const f = b.dataset.filter;
      fbtns.forEach(x => {
        const on = x === b;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-selected', String(on));
      });
      files.forEach(s => s.classList.toggle('is-hidden', f !== 'all' && s.dataset.file !== f));
      // the page just got shorter · don't strand the reader below the content
      const first = files.find(s => !s.classList.contains('is-hidden'));
      if (first){
        const top = Math.max(0, first.offsetTop - 150);
        if (scrollY > top) goTo(top);
      }
    }));
  }

  const lb = $('.lb');
  const allItems = $$('[data-lb][data-full]');
  if (lb && allItems.length){
    const lbImg = $('.lb__fig img', lb);
    const noEl  = $('.lb__no', lb),  capEl = $('.lb__cap', lb);
    const locEl = $('.lb__loc', lb), cntEl = $('.lb__count', lb);
    const pad = n => String(n).padStart(2, '0');
    // the reel is rebuilt on open so arrowing stays inside the active filter
    let lbItems = allItems, total = allItems.length, idx = 0, lastFocus = null;

    function show(n){
      idx = (n + total) % total;
      const el = lbItems[idx], thumb = $('img', el);
      lbImg.src = el.dataset.full;
      lbImg.alt = thumb ? thumb.alt : (el.dataset.cap || '');
      noEl.innerHTML = el.dataset.no || '';
      capEl.textContent = el.dataset.cap || '-';
      locEl.textContent = el.dataset.loc || '-';
      cntEl.innerHTML = `<b>${pad(idx + 1)}</b> / ${total}`;
      // quietly warm the neighbours so arrowing through never stalls
      [1, -1].forEach(d => { const nx = lbItems[(idx + d + total) % total]; if (nx) new Image().src = nx.dataset.full; });
    }
    function openLb(el){
      lastFocus = document.activeElement;
      lbItems = allItems.filter(x => x.offsetParent !== null);   // visible only
      if (!lbItems.length) lbItems = allItems;
      total = lbItems.length;
      show(Math.max(0, lbItems.indexOf(el)));
      lb.classList.add('show'); lb.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lb-open');
      window.__lenis && window.__lenis.stop();
      $('.lb__x', lb).focus();
    }
    function closeLb(){
      lb.classList.remove('show'); lb.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lb-open');
      window.__lenis && window.__lenis.start();
      lastFocus && lastFocus.focus && lastFocus.focus();
    }

    allItems.forEach(el => {
      if (el.tagName !== 'BUTTON'){           // the masonry figures
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'button');
        el.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openLb(el); }
        });
      }
      el.addEventListener('click', () => openLb(el));
    });

    $$('[data-lb-close]', lb).forEach(b => b.addEventListener('click', closeLb));
    $('[data-lb-prev]', lb).addEventListener('click', () => show(idx - 1));
    $('[data-lb-next]', lb).addEventListener('click', () => show(idx + 1));
    addEventListener('keydown', e => {
      if (!lb.classList.contains('show')) return;
      if (e.key === 'Escape')     closeLb();
      if (e.key === 'ArrowLeft')  show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
    // swipe through the ledger on touch
    let sx = 0, sy = 0;
    lb.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, {passive:true});
    lb.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
    }, {passive:true});
  }

  /* =================================================================
     SIZE SELECTOR + YEAR
     ================================================================= */
  $$('[data-year]').forEach(el => el.textContent = new Date().getFullYear());

  /* =================================================================
     MOTION LAYER
     ================================================================= */
  // smooth scroll (Lenis if present)
  if (!reduce && window.Lenis){
    const lenis = new Lenis({ lerp:.09, wheelMultiplier:1.05 });
    window.__lenis = lenis;   // the archive filter + lightbox drive it too
    (function raf(t){ lenis.raf(t); requestAnimationFrame(raf); })();
  }

  // parallax media (subtle · ratio stays ≤ .2)
  const pxEls = $$('[data-parallax]');
  if (pxEls.length && !reduce){
    let praf = null;
    /* The shift is measured against the FRAME (the parent), never the
       image's own transformed box, and is capped at half the over-scale,
       so an edge can never slide into view at any viewport height. */
    function par(){
      praf = null;
      pxEls.forEach(el => {
        const box = el.parentElement || el;
        const r = box.getBoundingClientRect();
        const ratio = +el.dataset.parallax || .12;
        const prog = Math.max(-1, Math.min(1, ((r.top + r.height / 2) - innerHeight / 2) / innerHeight));
        const scale = 1 + ratio * 1.6;                  // headroom = h * ratio * .8
        const shift = -prog * ratio * r.height * .5;    // travel   = h * ratio * .5
        el.style.transform = `translateY(${shift.toFixed(1)}px) scale(${scale.toFixed(3)})`;
      });
    }
    addEventListener('scroll', () => { if (!praf) praf=requestAnimationFrame(par); }, {passive:true});
    addEventListener('resize', () => { if (!praf) praf=requestAnimationFrame(par); }, {passive:true});
    par();
  }

  /* =================================================================
     FOOTER JOIN
     -----------------------------------------------------------------
     No JS. The footer signup is a real {% form 'customer' %} that posts to
     Shopify and creates the contact with marketing consent, so it keeps
     working with JS disabled. Success and error states render server-side
     in sections/footer.liquid.
     ================================================================= */

  /* =================================================================
     CART / BAG · Shopify AJAX Cart API
     -----------------------------------------------------------------
     The bag is Shopify's cart, not localStorage. The drawer is rendered
     server-side by snippets/cart-drawer.liquid on first paint, then this
     module re-renders it after every mutation. Keep the markup below in
     sync with that snippet or the drawer restyles on first add.

     Line items are addressed by `key`, which is what /cart/change.js wants.
     Size buttons carry data-variant (the variant id) from the Liquid.
     ================================================================= */
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // matches Liquid's money_without_trailing_zeros · cents in, "$58" or "$58.50" out
  const money = cents => {
    const n = cents / 100;
    return '$' + (n % 1 === 0 ? n.toLocaleString('en-US') : n.toFixed(2));
  };

  async function cartAPI(path, body){
    const res = await fetch(ROOT + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    const data = await res.json().catch(() => ({}));
    // Shopify answers 422 for sold out / over-stock, with a human-readable description
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong.');
    return data;
  }

  const getCart    = ()         => cartAPI('cart.js');
  const addItem    = (id, qty)  => cartAPI('cart/add.js',    { items:[{ id: Number(id), quantity: qty || 1 }] });
  const changeItem = (key, qty) => cartAPI('cart/change.js', { id: key, quantity: qty });

  const drawer   = $('.drawer');
  const countEls = $$('.nav__cart b');

  function syncCount(n, bump){
    countEls.forEach(b => b.textContent = n);
    if (bump) $$('.nav__cart').forEach(c => {
      c.classList.add('bump'); setTimeout(() => c.classList.remove('bump'), 320);
    });
  }

  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g,
    c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  function renderBag(cart){
    const wrap = $('.drawer__items');
    if (wrap){
      if (!cart.item_count){
        wrap.innerHTML = '<div class="drawer__empty">Your bag is empty.</div>';
      } else {
        wrap.innerHTML = cart.items.map(it => {
          const variant = /Default/i.test(it.variant_title || '') ? '' : esc(it.variant_title);
          const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
          return `
        <div class="bag-item" data-key="${esc(it.key)}">
          <img class="bag-item__img" src="${esc(img)}" alt="" loading="lazy" width="100" height="125">
          <div>
            <div class="bag-item__name">${esc(it.product_title)}</div>
            <div class="bag-item__sub">${variant}</div>
            <div class="bag-item__qty">
              <button data-q="-1" data-key="${esc(it.key)}" aria-label="Decrease quantity">-</button>
              <span>${it.quantity}</span>
              <button data-q="1" data-key="${esc(it.key)}" aria-label="Increase quantity">+</button>
            </div>
            <span class="bag-item__rm" data-rm="${esc(it.key)}" role="button" tabindex="0">Remove</span>
          </div>
          <div class="bag-item__price">${money(it.final_line_price)}</div>
        </div>`;
        }).join('');
      }
    }
    const sub = $('.drawer__sub b'); if (sub) sub.textContent = money(cart.total_price);
    const co  = $('.drawer__checkout'); if (co) co.toggleAttribute('disabled', !cart.item_count);
  }

  function openCart(){
    if (!drawer) return;
    drawer.classList.add('show');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-open');
    // the drawer is already painted; refresh in the background so it is never stale
    getCart().then(c => { renderBag(c); syncCount(c.item_count); }).catch(() => {});
  }
  function closeCart(){
    if (!drawer) return;
    drawer.classList.remove('show');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-open');
  }

  // open / close wiring
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  $('.drawer__scrim') && $('.drawer__scrim').addEventListener('click', closeCart);
  $('.drawer__close') && $('.drawer__close').addEventListener('click', closeCart);
  addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  // qty / remove (delegated) · qty is read from the DOM so rapid clicks stay correct
  $('.drawer__items') && $('.drawer__items').addEventListener('click', async e => {
    const q  = e.target.closest('[data-q]');
    const rm = e.target.closest('[data-rm]');
    if (!q && !rm) return;

    const row = e.target.closest('.bag-item'); if (!row) return;
    const key = rm ? rm.dataset.rm : q.dataset.key;
    const cur = +(row.querySelector('.bag-item__qty span') || {}).textContent || 0;
    const next = rm ? 0 : Math.max(0, cur + (+q.dataset.q));

    row.style.opacity = '.45';
    try {
      const cart = await changeItem(key, next);
      renderBag(cart); syncCount(cart.item_count);
    } catch(err){
      row.style.opacity = '';
      toast(err.message);
    }
  });

  /* product modules: size selection + add to bag
     Each size button carries data-variant. Sold-out sizes arrive disabled
     from the Liquid, so they cannot be selected in the first place. */
  async function addSelected(prod, opts){
    const sel = $('.buy__sizes button.sel, .sizes button.sel', prod);
    if (!sel || !sel.dataset.variant){
      const grp = $('.buy__sizes, .sizes', prod);
      const shake = () => {
        grp && grp.animate([{transform:'translateX(0)'},{transform:'translateX(-6px)'},
          {transform:'translateX(6px)'},{transform:'translateX(0)'}],{duration:240});
        toast((opts && opts.msg) || 'Select a size first');
      };
      if (opts && opts.scrollTo){ prod.scrollIntoView({behavior:'smooth', block:'center'}); setTimeout(shake, 480); }
      else shake();
      return;
    }

    const btn = opts && opts.btn;
    if (btn) btn.disabled = true;
    try {
      await addItem(sel.dataset.variant, 1);
      const cart = await getCart();
      renderBag(cart); syncCount(cart.item_count, true);
      toast('Added to bag', true);
      setTimeout(openCart, 420);
    } catch(err){
      toast(err.message);           // e.g. "All 3 Claim Tag Tee - L are in your cart."
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  $$('[data-product]').forEach(prod => {
    const sizes = $$('.buy__sizes button, .sizes button', prod);
    sizes.forEach(s => s.addEventListener('click', () => {
      if (s.disabled) return;
      sizes.forEach(x => x.classList.remove('sel'));
      s.classList.add('sel');
    }));
    const add = $('[data-add]', prod);
    add && add.addEventListener('click', e => { e.preventDefault(); addSelected(prod, { btn: add }); });
  });

  // sticky mobile buy bar · tracks whichever piece is currently in view
  const sticky = $('[data-stickybuy]');
  const buySections = $$('.buy[data-product]');
  if (sticky && buySections.length){
    let curProd = buySections[0];
    const sName = $('.stickybuy__name', sticky), sPrice = $('.stickybuy__price', sticky);
    const setCur = (prod) => {
      if (prod === curProd) return;
      curProd = prod;
      if (sName) sName.textContent = prod.dataset.name;
      if (sPrice) sPrice.textContent = `$${prod.dataset.price} · Lost & Found`;
    };
    const sAdd = $('[data-stickybuy-add]', sticky);
    sAdd && sAdd.addEventListener('click', () => {
      addSelected(curProd, { btn: sAdd, scrollTo: true, msg: 'Pick your size' });
    });
    const footEl = $('.footer');
    const syncSticky = () => {
      const footTop = footEl ? footEl.getBoundingClientRect().top : Infinity;
      const show = scrollY > 140 && footTop > innerHeight + 40 && !document.body.classList.contains('cart-open');
      sticky.classList.toggle('show', show);
      // active piece = the last product section whose top has crossed mid-viewport
      let active = buySections[0];
      buySections.forEach(s => { if (s.getBoundingClientRect().top < innerHeight * .5) active = s; });
      setCur(active);
    };
    addEventListener('scroll', syncSticky, {passive:true});
    addEventListener('resize', syncSticky, {passive:true});
    syncSticky();
  }

  /* Checkout needs no JS. The button is a submit inside a form posting to
     /cart with name="checkout", which is Shopify's native path and keeps
     working if JS fails. See snippets/cart-drawer.liquid. */

  // reconcile on load, and again when returning via bfcache (back button)
  getCart().then(c => { renderBag(c); syncCount(c.item_count); }).catch(() => {});
  addEventListener('pageshow', e => {
    if (e.persisted) getCart().then(c => { renderBag(c); syncCount(c.item_count); }).catch(() => {});
  });
})();
